import * as React from 'react';
import {useEffect, useState} from 'react';
import classnames from "classnames";
import {FormattedMessage} from "react-intl";

import {
    useResidenceExplorerStore,
    selectCurrentSunStudy,
    selectSetup,
    selectSunStudyFrame,
    selectSunStudyStarted,
    selectSunStudyType,
} from "features/residenceExplorer/store/useResidenceExplorerStore";
import {useDeviceStore, selectIsMobile} from "features/ui/store/useDeviceStore";

import './_residenceExplorerSunStudySlider.scss'

import {P} from "@atoms/Text/P";
import {Icon} from "@atoms/Media/Icon";
import {Slider} from "@atoms/FormElements/Slider";
import { Margin } from 'features/ui/enums';


export const ResidenceExplorerSunStudySlider: React.FunctionComponent = () => {
    const setup = useResidenceExplorerStore(selectSetup);
    const _isMobile = useDeviceStore(selectIsMobile);
    const currentSunStudy = useResidenceExplorerStore(selectCurrentSunStudy);
    const _sunStudyPlaying = useResidenceExplorerStore(selectSunStudyStarted);
    const currentFrame = useResidenceExplorerStore(selectSunStudyFrame);
    const _explorerType = useResidenceExplorerStore(selectSunStudyType);
    const setSunStudyFrame = useResidenceExplorerStore(state => state.setSunStudyFrame);
    const wec360 = currentSunStudy && currentSunStudy.imageCount === 3;

    const [currentNumber, setCurrentNumber] = useState<number>(currentFrame);

    useEffect(() => {
        setSunStudyFrame(currentNumber);
    }, [currentNumber, setSunStudyFrame]);

    useEffect(() => {
        setCurrentNumber(currentFrame);
    }, [currentFrame]);

    if(!setup || !currentSunStudy) return null;

    const setCurrentHour = (frame: number) => {
        if(wec360) return '';
        const numberOfHours = currentSunStudy.endHour - currentSunStudy.startHour;
        const hourInterval = currentSunStudy.imageCount / numberOfHours;
        const currentHour = Math.ceil(frame/hourInterval + currentSunStudy.startHour);
        return `${currentHour}:00`;
    };

    const onChange = (result: { max: number; min: number; values: number[] }) => {
        setCurrentNumber(result.values[0]);
    };

    const containerClasses = classnames('sun-study-slider', {
        'sun-study-slider--wec': wec360,
    });

    const snapPoints = [...Array(currentSunStudy.imageCount).keys()];

    return (
        <div className={containerClasses}>
            {wec360 ?
                <div className="sun-study-slider__icon sun-study-slider__icon--up">
                    <Icon name="arrow-link" size={12} left />
                    <Icon name="half-sun" size={32} />
                </div> :
                <div className="sun-study-slider__icons">
                    <div className="sun-study-slider__icon sun-study-slider__icon--up">
                        <Icon name="arrow-link" size={12} left />
                        <Icon name="half-sun" size={32} />
                    </div>

                    <P 
                        margin={Margin.NONE} 
                        center 
                    >
                        Kl. {setCurrentHour(currentFrame)}
                    </P>

                    <div className="sun-study-slider__icon sun-study-slider__icon--down">
                        <Icon name="half-sun" size={32} />
                        <Icon name="arrow-link" size={12} right />
                    </div>
                </div>
            }
            {wec360 &&
                <div className="sun-study-slider__description">
                    <span><FormattedMessage id="jm.components.SunStudySlider.morning" /></span>
                    <span><FormattedMessage id="jm.components.SunStudySlider.evning" /></span>
                    <span><FormattedMessage id="jm.components.SunStudySlider.night" /></span>
                </div>
            }

            <div className="sun-study-slider__slider">
            <Slider
                    min={0}
                    max={(wec360) ?
                        currentSunStudy.imageCount :
                        currentSunStudy.imageCount - 2}
                    values={[currentNumber]}
                    onValuesUpdated={onChange}
                    snap
                    snapPoints={snapPoints}
                />
            </div>

            {wec360 &&
                <div className="sun-study-slider__icon sun-study-slider__icon--down">
                    <Icon name="half-sun" size={32}/>
                    <Icon name="arrow-link" size={12} right/>
                </div>
            }
        </div>
    )
};
